(() => {
  const RELEASE = 'original-pastel-2026-10-04';
  const SCROLL_STEPS = [25, 50, 75, 100];
  const sentScroll = new Set();
  let active = false;
  let exposureSent = false;

  const pageType = () => location.pathname.startsWith('/collections/') ? 'collection' :
    location.pathname === '/search' ? 'search' :
    location.pathname.startsWith('/products/') ? 'product' :
    location.pathname === '/' ? 'home' : 'other';
  const viewport = () => innerWidth < 750 ? 'mobile' : innerWidth < 990 ? 'tablet' : 'desktop';
  const path = () => location.pathname.slice(0, 240);

  function publish(name, data, attempts = 20) {
    if (!active) return;
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, data);
    } else if (attempts > 0) {
      setTimeout(() => publish(name, data, attempts - 1), 250);
    }
  }

  function eventData(extra = {}) {
    return {release: RELEASE, design: 'pastel', pageType: pageType(), path: path(), ...extra};
  }

  function start() {
    if (active) return;
    active = true;
    if ((pageType() === 'collection' || pageType() === 'search') && !exposureSent) {
      exposureSent = true;
      publish('lennies:card_exposure', eventData());
    }
  }

  function stop() {
    active = false;
    exposureSent = false;
    sentScroll.clear();
  }

  function consentAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }

  function syncConsent() {
    if (consentAllowed()) start(); else stop();
  }

  function productCard(target) {
    return target.closest('collection-component #product-grid > .grid__item:not(.lennie-grid-trust)');
  }

  function cardPosition(card) {
    return [...card.parentElement.children]
      .filter(item => item.matches('.grid__item:not(.lennie-grid-trust)'))
      .indexOf(card) + 1;
  }

  function productHandle(target) {
    const link = target.closest('a[href*="/products/"]') || productCard(target)?.querySelector('a[href*="/products/"]');
    const match = link?.getAttribute('href')?.match(/\/products\/([^?#/]+)/);
    return match ? match[1].slice(0, 120) : undefined;
  }

  function zoneFor(target) {
    if (target.closest('collection-component #product-grid')) return 'product_grid';
    if (target.closest('header, .section-header')) return 'header';
    if (target.closest('nav')) return 'navigation';
    if (target.closest('footer')) return 'footer';
    if (target.closest('.shopify-section')) return 'content_section';
    return 'main';
  }

  document.addEventListener('click', event => {
    if (!active || !(event.target instanceof Element)) return;
    const target = event.target;
    const card = productCard(target);
    if (card) {
      const isAdd = Boolean(target.closest('.quick-add, [name="add"], .quick-add__submit'));
      const isProductLink = Boolean(target.closest('a[href*="/products/"]'));
      if (isAdd || isProductLink) publish('lennies:card_interaction', eventData({
        action: isAdd ? 'add_to_cart' : 'product_click',
        productHandle: productHandle(target),
        position: cardPosition(card),
      }));
    }
    if (target.closest('input, textarea, select, [contenteditable="true"], form')) return;
    const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight, 1);
    publish('lennies:ux_click', eventData({
      zone: zoneFor(target),
      xBucket: Math.min(9, Math.max(0, Math.floor((event.clientX / Math.max(innerWidth, 1)) * 10))),
      yBucket: Math.min(9, Math.max(0, Math.floor(((scrollY + event.clientY) / documentHeight) * 10))),
      viewport: viewport(),
    }));
  }, {passive: true});

  let scrollQueued = false;
  addEventListener('scroll', () => {
    if (!active || scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(() => {
      scrollQueued = false;
      const available = Math.max(document.documentElement.scrollHeight - innerHeight, 1);
      const depth = Math.min(100, Math.round((scrollY / available) * 100));
      for (const step of SCROLL_STEPS) if (depth >= step && !sentScroll.has(step)) {
        sentScroll.add(step);
        publish('lennies:scroll_depth', eventData({depth: step, viewport: viewport()}));
      }
    });
  }, {passive: true});

  document.addEventListener('visitorConsentCollected', syncConsent);
  let checks = 0;
  const ready = setInterval(() => {
    checks += 1;
    if (window.Shopify?.customerPrivacy || checks >= 20) {
      clearInterval(ready);
      syncConsent();
    }
  }, 250);
})();
